import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Role } from '../../models/roles';
import { ReportProvider } from '../../providers/report/report';
import { UserProvider } from '../../providers/user/user';


@IonicPage()
@Component({
  selector: 'page-report-user',
  templateUrl: 'report-user.html',
})
export class ReportUserPage {

  users;
  period;
  isAdmin: boolean;
  relativeTime: boolean = false;
  selectedUser;

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public globalVars: GlobalVars,
    public reportProvider: ReportProvider,
    public toastCtrl: ToastController,
    public userProvider: UserProvider
  ) {
    this.isAdmin = this.globalVars.user.role == Role['admin'];
    // this.users = userProvider.getUserNames();

    this.loadUsers()
  }

  loadUsers() {
    this.userProvider.getUsersByHeadArea(this.globalVars.user.key, true).then(observable => observable.subscribe(users => this.users = users))
  }

  generate() {
    if (this.period) {

      // Mostrar loading
      let loading = this.loadingCtrl.create({
        content: 'Generando PDF...'
      });

      loading.present();

      this.reportProvider.userReport(this.period, this.selectedUser || this.globalVars.user, this.relativeTime)
        .then(() => loading.dismiss())
        .catch(error => loading.dismiss())
    }
    else this.showMessage('Introduzca todos los datos.');
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
  
}


// WEBPACK FOOTER //
// ./src/pages/report-user/report-user.ts